import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

export default function TermsNew() {
    return (
        <Container
            maxWidth="md"
            sx={{
                py: { xs: 4, md: 8 },
            }}
        >
            {/* Заголовок */}
            <Typography
                component="h1"
                sx={{
                    fontSize: { xs: 26, md: 32 },
                    fontWeight: 500,
                    mb: 3,
                    letterSpacing: "-0.01em",
                }}
            >
                Пользовательское соглашение
            </Typography>

            <Typography
                sx={{
                    fontSize: 15,
                    color: "text.secondary",
                    mb: 6,
                    maxWidth: 720,
                }}
            >
                Настоящее Пользовательское соглашение определяет условия использования
                онлайн-ресурсов, принадлежащих Елене Корневой, и регулирует отношения
                между Администрацией и Пользователем.
            </Typography>

            <Divider sx={{ mb: 6 }} />

            {/* 1. Общие положения */}
            <Section title="1. Общие положения">
                <Text>
                    1.1. Настоящее Соглашение применяется ко всем веб-ресурсам,
                    размещённым по адресам elenakorneva.ru, elenakorneva.site,
                    их субдоменам, а также к сервису Helenbot (далее — Ресурсы).
                </Text>

                <Text>
                    1.2. Ресурсы принадлежат самозанятому консультанту
                    Корневой Елене Викторовне и управляются ею либо
                    уполномоченными представителями.
                </Text>

                <Text>
                    1.3. Используя Ресурсы, Пользователь подтверждает согласие
                    с условиями настоящего Соглашения.
                </Text>

                <Text>
                    1.4. Администрация вправе вносить изменения в Соглашение.
                    Актуальная редакция всегда доступна на Ресурсах.
                </Text>
            </Section>

            {/* 2. Термины */}
            <Section title="2. Термины и определения">
                <Text>
                    <strong>Пользователь</strong> — дееспособное физическое лицо,
                    использующее Ресурсы в личных целях.
                </Text>

                <Text>
                    <strong>Ресурсы</strong> — сайты, цифровые платформы и сервисы,
                    предоставляющие информационные и образовательные материалы.
                </Text>

                <Text>
                    <strong>Содержание</strong> — тексты, изображения, методические
                    материалы, интерфейсы, дизайн и иные объекты интеллектуальной
                    собственности, размещённые на Ресурсах.
                </Text>
            </Section>

            {/* 3. Предмет соглашения */}
            <Section title="3. Предмет соглашения">
                <Text>
                    3.1. Администрация предоставляет Пользователю доступ к
                    информационным и образовательным материалам, размещённым
                    на Ресурсах.
                </Text>

                <Text>
                    3.2. Материалы носят образовательный и информационный характер
                    и не являются медицинской, психологической или
                    психотерапевтической помощью.
                </Text>

                <Text>
                    3.3. Результаты использования материалов зависят от
                    индивидуальных факторов и степени вовлечённости Пользователя
                    и не могут быть гарантированы.
                </Text>
            </Section>

            {/* 4. Права и обязанности */}
            <Section title="4. Права и обязанности сторон">
                <Text>
                    4.1. Администрация вправе обновлять содержание Ресурсов,
                    изменять функциональность и временно ограничивать доступ
                    по техническим причинам.
                </Text>

                <Text>
                    4.2. Пользователь обязуется использовать Ресурсы законно,
                    уважать права интеллектуальной собственности и не
                    распространять материалы без письменного согласия
                    Администрации.
                </Text>
            </Section>

            {/* 5. Интеллектуальная собственность */}
            <Section title="5. Интеллектуальная собственность">
                <Text>
                    5.1. Все материалы Ресурсов защищены законодательством РФ
                    об интеллектуальной собственности.
                </Text>

                <Text>
                    5.2. Копирование, распространение и иное использование
                    материалов допускается только с письменного согласия
                    Администрации.
                </Text>
            </Section>

            {/* 6. Ограничение ответственности */}
            <Section title="6. Ограничение ответственности">
                <Text>
                    6.1. Администрация не несёт ответственности за возможные
                    убытки, возникшие вследствие использования Ресурсов,
                    за исключением случаев, предусмотренных законом.
                </Text>

                <Text>
                    6.2. Администрация не отвечает за перебои в работе,
                    вызванные техническими или внешними факторами.
                </Text>
            </Section>

            {/* 7. Заключительные положения */}
            <Section title="7. Заключительные положения">
                <Text>
                    7.1. Настоящее Соглашение регулируется законодательством
                    Российской Федерации.
                </Text>

                <Text>
                    7.2. Все споры подлежат досудебному урегулированию,
                    а при невозможности — рассмотрению в суде по месту
                    регистрации Администрации.
                </Text>
            </Section>
        </Container>
    );
}

/* Вспомогательные компоненты */

function Section({ title, children }) {
    return (
        <Box sx={{ mb: 6 }}>
            <Typography
                component="h2"
                sx={{
                    fontSize: { xs: 18, md: 20 },
                    fontWeight: 500,
                    mb: 2,
                }}
            >
                {title}
            </Typography>
            {children}
        </Box>
    );
}

function Text({ children }) {
    return (
        <Typography
            sx={{
                fontSize: 15,
                lineHeight: 1.7,
                color: "text.primary",
                mb: 2,
                maxWidth: 720,
            }}
        >
            {children}
        </Typography>
    );
}
